// extracted by mini-css-extract-plugin
export default {"btn":"Navigation_btn__wQtUd","nav":"Navigation_nav__qdBnL","active":"Navigation_active__9FxK8"};